import { Box, Divider, Flex, Group, Radio, RadioGroup } from '@byecode/ui'
import type { ConditionConfig, FlowNode } from '@lighthouse/shared'
import { ConditionRunType } from '@lighthouse/shared'
import React from 'react'
import styled from 'styled-components'

import Branch from './Branch'

interface ConditionConfigureProps {
    allParentNodes: FlowNode[]
    value: ConditionConfig
    onChange: (value: ConditionConfig) => void
}

const SCxGroupRadioLabel = styled.div`
    color: var(--color-gray-900);
    font-size: 14px;
    line-height: 22px;
`

const SCxGroupRadioDesc = styled.div`
    color: var(--color-gray-400);
    font-size: 14px;
    line-height: 22px;
`

const SCxRadioGroup = styled(RadioGroup)`
    display: flex;
    flex-direction: column;
    gap: 8px;
`

const options = [
    {
        label: '并行分支',
        value: ConditionRunType.PARALLEL,
        description: '执行所有符合条件的分支。'
    },
    {
        label: '唯一分支',
        value: ConditionRunType.UNIQUE,
        description: '按照从上到下的顺序，只执行第一个符合条件的分支，其他分支即使符合条件也不再执行。'
    }
]

export const ConditionConfigure: React.FC<ConditionConfigureProps> = ({ allParentNodes, value, onChange }) => {
    return (
        <>
            {/* <CollapseBox label="设置条件" required> */}
            {/* <CM.Tip style={{ padding: '0 16px' }}>满足条件的数据才能进入该分支；满足条件分支下的节点都会执行（并行分支）</CM.Tip> */}
            <Branch
                allParentNodes={allParentNodes}
                value={value.filterGroup}
                onChange={filterGroup => onChange({ ...value, filterGroup })}
            />
            {/* </CollapseBox> */}

            <Divider />
            <Group label="运行方式">
                <Box px={8}>
                    <SCxRadioGroup
                        name="config.runType"
                        value={value.runType}
                        onChange={val => onChange({ ...value, runType: val as ConditionRunType })}
                    >
                        {options.map(option => (
                            <Flex key={option.value} alignItems="flex-start" gap={8}>
                                <Radio
                                    size="xs"
                                    value={option.value}
                                    checked={value.runType === option.value}
                                    onChange={() => onChange({ ...value, runType: option.value })}
                                    style={{ paddingTop: '7px' }}
                                />
                                <Flex direction="column">
                                    <SCxGroupRadioLabel>{option.label}</SCxGroupRadioLabel>
                                    <SCxGroupRadioDesc>{option.description}</SCxGroupRadioDesc>
                                </Flex>
                            </Flex>
                        ))}
                    </SCxRadioGroup>
                </Box>
            </Group>
        </>
    )
}
